import {PureComponent} from "react"
import PropTypes from "prop-types"

import notify from "@irati/utils/notify"
import getMessage from "@irati/utils/lang/helpers/getMessage"
import {injectIntl} from "@irati/utils/lang"
import {updateSchedule} from "@irati/insights/services/schedule"
import {ENABLED} from "@irati/insights/constants/schedule"

const SUCCESS_MESSAGE = "insights.schedule.launch.successMessage"

class Launch extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleAction = () => {
    return this.handleClick()
  }

  handleClick = () => {
    this.setState({loading: true})
    return updateSchedule({...this.props.schedule, status: ENABLED})
      .then(() => {
        this.props.onChange()
        notify.success({message: this.props.formatMessage({id: SUCCESS_MESSAGE}), position: "top-right"})
      })
      .catch((error) => {
        notify.error({message: getMessage(this, error.contentKey), position: "top-right"})
      })
  }

  render() {
    return null
  }
}

export default injectIntl(Launch, {withRef: true})
